// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@100;200;300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Template Name: Jordo - ESports, Online Game and Gaming Store HTML Template
Author: Askbootstrap
Author URI: https://wrapbootstrap.com/user/gurdeep
Version: 1.0
*/
/*
- body
- Extra
- Filters
- Top Nav
- Card
- Footer
- Mobile Media
*/
/* body */
body {
    background: #121212;
    font-size: 13px;
    color: #ffffff;
    font-family: 'IBM Plex Sans', sans-serif;
}
.bg-dark {
    background-color: #2a2a2a !important;
}
.bg-dark-2 {
    background-color: #121212 !important;
}
.gradient-1 {
    background: rgb(65, 0, 185);
    background: linear-gradient(to right bottom, rgb(65, 0, 185), rgb(0, 198, 255));
}
.gradient-2 {
    background: rgb(240, 75, 90);
    background: linear-gradient(to right bottom, rgb(240, 75, 90), rgb(237, 169, 93));
}
/* Extra */
.border {
    border: 1px solid #2a2a2a!important;
}
.border-bottom {
    border-bottom: 1px solid #2a2a2a!important;
}
.border-top {
    border-top: 1px solid #2a2a2a!important;
}
.border-right {
    border-right: 1px solid #2a2a2a!important;
}
.border-left {
    border-left: 1px solid #2a2a2a!important;
}
.position-sticky {
    top: 86px;
}
a{
    text-decoration: none !important;
}
.btn {
    border-radius: 0px;
    font-size: 14px;
    padding: 9px 21px;
}
.btn-link {
    color: #b9b9b9;
}
.btn-sm {
    font-size: 12px;
    padding: 5px 14px;
}
.btn-outline-light {
    border-color: rgba(255, 255, 255, 0.2);
}
.btn-light {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: #fff;
    font-size: 13px;
    text-transform: uppercase;
}
.btn-lg {
    padding: 13px 46px;
}
.custom-checkbox .custom-control-label::before {
    border-radius: 0px;
    border: none;
    background: #404040;
    box-shadow: none !important;
}
.custom-control {
    line-height: 26px;
}
.form-control {
    background: #404040;
    border: 1px solid #404040;
    border-radius: 0px;
    font-size: 14px;
    min-height: 42px;
    box-shadow: none !important;
}
.form-control:focus {
    background: #121212;
    border: none;
    border: 1px solid #6c757d;
}
.custom-control label {
    color: rgba(255,255,255,.5)!important;
    width: 100%;
    cursor: pointer;
}
input[type=text], input[type=tel], input[type=number], input[type=email], textarea, input[type=password] {
    color: #ffffff !important;
}
.card {
    border-radius: 0px;
    border: none;
    background: #2a2a2a;
}
.card-body {
    color: rgba(255,255,255,.5)!important;
}
.media .rounded-circle {
    width: 40px;
}
.follow-us a {
    color: #878787;
    font-size: 26px;
    margin: 0 18px;
}
.follow-us:hover a {
    color: #fff;
}
.follow-us a:hover {
    color: #878787;
}
.rating {
    padding: 36px !important;
}
.specifications .nav-tabs {
    border-color: #616161 !important;
    margin-bottom: 30px;
}
.specifications .nav-tabs .nav-link {
    border: none;
    position: relative;
    border-radius: 0px;
    font-size: 13px;
    color: rgba(255,255,255,.5);
    padding: 0 0 29px 0;
}
.specifications .nav-tabs .nav-link.active {
    background: transparent !important;
    color: #fff;
}
.specifications .nav-tabs .nav-item {
    margin: 0 30px 0 0;
}
.specifications .nav-tabs .nav-link:after {
   content: "";
   height: 5px;
   background: transparent;
   position: absolute;
   left: 0;
   right: 0;
   bottom: -1px;
}
.specifications .nav-tabs .nav-link.active:after {
    background: #007bff;
}
.btn-outline-facebook {
    color: #ffffff !important;
    background: #3B5998 !important;
}
.btn-outline-instagram {
    background: #125688 !important;
    color: #fff !important;
}
.alert {
    border-radius: 0px;
    border: none;
}
.custom-select.is-invalid, .was-validated .custom-select:invalid, .jumbotron {
    background-color: #2a2a2a;
}
.dropdown-divider {
    border-top: 1px solid #353535;
}
.custom-select {
    border: none;
    border-radius: 0px;
    background-color: #2a2a2a;
    font-size: 14px;
    min-height: 42px;
}
.custom-file-label {
    border: none;
    border-radius: 0px;
    background-color: #2a2a2a;
    font-size: 14px;
}
.form-control:disabled, .form-control[readonly] {
    background-color: #000000;
}
.bg-light {
    background-color: #f8f9fa!important;
    color: #000;
}
.bg-light .card-body{
    color: #000 !important;
}
.breadcrumb, .input-group-text {
    background-color: #2a2a2a;
    border-color: #2a2a2a;
}
.list-group-item{
    background-color: #2a2a2a;
}
.dropdown-menu {
    background: #2a2a2a;
    border-radius: 0px;
    margin: 0;
    border: 1px solid #353535;
    color: #fff;
    box-shadow: 0px 6px 10px rgba(0,0,0,.2)!important;
}
.dropdown-item {
    color: rgba(255,255,255,.5);
}
.dropdown-item:hover {
    background: #000;
    color: #fff;
}
.dropdown:hover .dropdown-menu {
    display: block;
   visibility: visible;
   opacity:1;
   transform: translateY(0px);
   transition:.5s ease all;
}
.dropdown-menu {
   display: block;
   visibility: hidden;
   opacity:0;
   transform: translateY(50px);
   transition:.5s ease all;
}
.dropdown-menu.show {
   display: block;
   visibility: visible;
   opacity:1;
   transform: translateY(0px);
   transition:.5s ease all;
}
.gradient-block h1 {
    font-size: 54px;
}
.help-block ul {
    margin: 0px;
    padding: 0px;
    list-style: none;
}
.help-block ul li {
    color: #f53838;
    font-size: 12px;
}
.carousel-indicators {
    margin: 11px 18px;
    left: auto;
}
.carousel-control-next, .carousel-control-prev {
   bottom: auto;
   background: #000;
   width: 35px;
   height: 35px;
   margin: 15px;
}
.carousel-control-next-icon, .carousel-control-prev-icon {
    width: 12px;
}
.carousel-control-prev {
    right: 36px;
    left: auto;
}
/* End Extra */
/* Filters */
.filters-search {
    position: relative;
}
.filters-search i {
    position: absolute;
    padding: 15px 14px;
}
.filters-search .form-control {
    padding-left: 42px;
}
.filters-card-header .btn-link {
    font-size: 14px;
    color: #fff;
    width: 100%;
    display: block;
}
.filters-card-body {
    padding: 20px 0 0 0;
}
/* End Filters */
/* Sidebar */
.img-profile {
    width: 80px;
}
.sidebar-widget {
    position: relative;
}
.sidebar-widget .nav-link {
    padding: 10px 7px;
    border-radius: 0px;
    position: relative;
    color: #bfbfbf;
}
.sidebar-widget .nav-link:hover, .sidebar-widget .nav-link:focus {
    color: #ffffff;
}
.sidebar-widget .nav-link:hover:before, .sidebar-widget .nav-link:focus:before {
    background: #007bff;
}
.sidebar-widget .nav-link i {
    min-width: 19px;
    display: inline-block;
    text-align: center;
    opacity: 0.5;
    margin: 0px 8px 0px 0px !important;
}
.sidebar-widget .nav-link:before {
    content: "";
    position: absolute;
    left: -15px;
    width: 4px;
    bottom: 5px;
    top: 5px;
    background: #2a2a2a;
}
.sidebar-widget .nav-link.active {
    background: transparent;
    font-weight: 500;
}
.sidebar-widget .nav-link.active:before {
    background: #fff;
}
/* End Sidebar */
/* Top Nav */
.navbar-dark .navbar-nav .nav-link {
    color: rgba(255,255,255,.8);
}
.osahan-nav-top .container {
    padding: 0 16px;
}
.osahan-nav-top .img-profile {
    width: 30px;
    height: 30px;
}
.osahan-nav-top .navbar-brand img {
    height: 31px;
    margin: -4px 0 0 0;
}
.osahan-nav-top .osahan-list-dropdown .nav-link i {
    font-size: 16px;
}
.osahan-nav-top .osahan-list-dropdown .nav-link .badge {
    position: absolute;
    border-radius: 50px;
    min-width: 15px;
    height: 15px;
    font-size: 9px;
    padding: 0px;
    right: 1px;
    line-height: 15px;
    top: 11px;
}
.osahan-nav-top .nav-link {
    position: relative;
    height: 55px;
    display: flex;
    align-items: center;
}
.osahan-nav-top .navbar-search .form-control {
    background: #121212;
    min-height: 35px;
}
.osahan-nav-top .navbar-search .btn {
    background: #121212 !important;
    color: #74828e;
    padding: 0 12px;
    border: none;
}
.dropdown-list .dropdown-item {
    white-space: normal;
    padding-top: .5rem;
    padding-bottom: .5rem;
    border-left: 1px solid #353535;
    border-right: 1px solid #353535;
    border-bottom: 1px solid #353535;
    line-height: 1.3rem;
}
.dropdown-list {
    padding: 0;
    border: none;
    overflow: hidden;
    width: 20rem!important;
}
.dropdown-list .dropdown-header {
    background-color: #131313;
    border: 1px solid #353535;
    color: #fff;
    font-weight: 800;
    font-size: 14px;
    padding: .8rem 1rem;
}
.dropdown-list .icon-circle {
    height: 2.5rem;
    width: 2.5rem;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.no-arrow .dropdown-toggle::after {
    display: none;
}
.text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.dropdown .dropdown-menu, .dropdown-item {
    font-size: .85rem;
}
.text-gray-500 {
    color: #b7b9cc!important;
}
.dropdown-list-image {
    position: relative;
    height: 2.5rem;
    width: 2.5rem;
}
.dropdown-list-image img {
    height: 2.5rem;
    width: 2.5rem;
}
.dropdown-list-image .status-indicator {
    background-color: #eaecf4;
    height: .75rem;
    width: .75rem;
    border-radius: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
    border: .125rem solid #fff;
}
.dropdown-item {
    padding: 6px 1rem;
}
/* End Top Nav */
/* Card */
.osahan-card {
    margin-bottom: 35px;
}
.osahan-card-body h6 {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
/* End Card */
/* Footer */
.footer ul {
    margin: 0px;
    padding: 0px;
    list-style: none;
}
.footer ul li a {
    color: rgba(255,255,255,.5)!important;
}
.footer ul li {
    line-height: 28px;
}
.footer ul li a:hover {
    opacity: unset;
}
.footer h6 {
    font-size: 14px;
    margin-bottom: 20px;
}
.app .img-fluid {
    height: 32px;
}
/* End Footer */
/* Mobile Media */

@media (min-width: 0px) and (max-width: 767px) {
    .container {
		max-width: 100%;
    }
    .osahan-login {
        max-width: 430px;
        margin: auto;
    }
    .osahan-nav-top {
        padding: 0 0 !important;
    }
    .p-5 {
        padding: 2rem!important;
    }
    .osahan-nav-top .dropdown {
        position: static;
    }
    .osahan-nav-top .dropdown .dropdown-menu {
        left: 0;
        right: 0;
        width: 100% !important;
    }
    .position-sticky {
        margin-bottom: 30px;
    }
    .footer{
        display: none;
    }
    .footer ul li {
        text-align: center;
    }
    .footer h6 {
        text-align: center;
        margin: 30px 0 8px 0;
    }
    .footer-brand {
        text-align: center;
    }
    .newsletter-form .btn {
        width: 100%;
    }
    .app {
        text-align: center;
    }
    .osahan-copyright p {
        width: 100%;
        text-align: center;
        padding: 5px 0;
    }
    .osahan-copyright .d-flex {
        display: unset !important;
    }
}
@media (min-width: 768px) and (max-width: 1023px) {
    .container {
		max-width: 100%;
    }
    .footer h6 {
        margin: 30px 0 8px 0;
    }
    .footer-brand{
        margin-top: 30px;
    }
}
@media (min-width: 1024px) and (max-width: 1200px) {
	.container {
		max-width: 100%;
	}
}
/* End Mobile Media */
`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;;;;;CAKC;AACD;;;;;;;;CAQC;AAGD,SAAS;AACT;IACI,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,wCAAwC;AAC5C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,2BAA2B;IAG3B,+EAA+E;AACnF;AACA;IACI,4BAA4B;IAG5B,iFAAiF;AACrF;AACA,UAAU;AACV;IACI,mCAAmC;AACvC;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,uCAAuC;AAC3C;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,SAAS;AACb;AACA;IACI,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,oCAAoC;IACpC,YAAY;IACZ,WAAW;IACX,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,qCAAqC;IACrC,WAAW;IACX,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;GACG,WAAW;GACX,WAAW;GACX,uBAAuB;GACvB,kBAAkB;GAClB,OAAO;GACP,QAAQ;GACR,YAAY;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,8BAA8B;AAClC;AACA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,6BAA6B;AACjC;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,mCAAmC;IACnC,WAAW;AACf;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,yBAAyB;IACzB,WAAW;IACX,iDAAiD;AACrD;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,cAAc;GACf,mBAAmB;GACnB,SAAS;GACT,0BAA0B;GAC1B,uBAAuB;AAC1B;AACA;GACG,cAAc;GACd,kBAAkB;GAClB,SAAS;GACT,2BAA2B;GAC3B,uBAAuB;AAC1B;AACA;GACG,cAAc;GACd,mBAAmB;GACnB,SAAS;GACT,0BAA0B;GAC1B,uBAAuB;AAC1B;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,UAAU;AACd;AACA;GACG,YAAY;GACZ,gBAAgB;GAChB,WAAW;GACX,YAAY;GACZ,YAAY;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,UAAU;AACd;AACA,cAAc;AACd,YAAY;AACZ;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,WAAW;IACX,WAAW;IACX,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA,gBAAgB;AAChB,YAAY;AACZ;IACI,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,kCAAkC;AACtC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,QAAQ;IACR,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA,gBAAgB;AAChB,YAAY;AACZ;IACI,2BAA2B;AAC/B;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,8BAA8B;IAC9B,cAAc;IACd,eAAe;IACf,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,8BAA8B;IAC9B,+BAA+B;IAC/B,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;AACjB;AACA;IACI,cAAc;IACd,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,0BAA0B;AAC9B;AACA;IACI,iBAAiB;AACrB;AACA,gBAAgB;AAChB,SAAS;AACT;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA,aAAa;AACb,WAAW;AACX;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;AACA,eAAe;AACf,iBAAiB;;AAEjB;IACI;EACF,eAAe;IACb;IACA;QACI,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,gBAAgB;IACpB;IACA;QACI,OAAO;QACP,QAAQ;QACR,sBAAsB;IAC1B;IACA;QACI,mBAAmB;IACvB;IACA;QACI,aAAa;IACjB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;IACf;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,cAAc;IAClB;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI;EACF,eAAe;IACb;IACA;QACI,oBAAoB;IACxB;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;CACC;EACC,eAAe;CAChB;AACD;AACA,qBAAqB","sourcesContent":["/*\nTemplate Name: Jordo - ESports, Online Game and Gaming Store HTML Template\nAuthor: Askbootstrap\nAuthor URI: https://wrapbootstrap.com/user/gurdeep\nVersion: 1.0\n*/\n/*\n- body\n- Extra\n- Filters\n- Top Nav\n- Card\n- Footer\n- Mobile Media\n*/\n\n@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@100;200;300;400;500;600;700&display=swap');\n/* body */\nbody {\n    background: #121212;\n    font-size: 13px;\n    color: #ffffff;\n    font-family: 'IBM Plex Sans', sans-serif;\n}\n.bg-dark {\n    background-color: #2a2a2a !important;\n}\n.bg-dark-2 {\n    background-color: #121212 !important;\n}\n.gradient-1 {\n    background: rgb(65, 0, 185);\n    background: -moz-linear-gradient(to right bottom, rgb(65, 0, 185), rgb(0, 198, 255));\n    background: -webkit-linear-gradient(to right bottom, rgb(65, 0, 185), rgb(0, 198, 255));\n    background: linear-gradient(to right bottom, rgb(65, 0, 185), rgb(0, 198, 255));\n}\n.gradient-2 {\n    background: rgb(240, 75, 90);\n    background: -moz-linear-gradient(to right bottom, rgb(240, 75, 90), rgb(237, 169, 93));\n    background: -webkit-linear-gradient(to right bottom, rgb(240, 75, 90), rgb(237, 169, 93));\n    background: linear-gradient(to right bottom, rgb(240, 75, 90), rgb(237, 169, 93));\n}\n/* Extra */\n.border {\n    border: 1px solid #2a2a2a!important;\n}\n.border-bottom {\n    border-bottom: 1px solid #2a2a2a!important;\n}\n.border-top {\n    border-top: 1px solid #2a2a2a!important;\n}\n.border-right {\n    border-right: 1px solid #2a2a2a!important;\n}\n.border-left {\n    border-left: 1px solid #2a2a2a!important;\n}\n.position-sticky {\n    top: 86px;\n}\na{\n    text-decoration: none !important;\n}\n.btn {\n    border-radius: 0px;\n    font-size: 14px;\n    padding: 9px 21px;\n}\n.btn-link {\n    color: #b9b9b9;\n}\n.btn-sm {\n    font-size: 12px;\n    padding: 5px 14px;\n}\n.btn-outline-light {\n    border-color: rgba(255, 255, 255, 0.2);\n}\n.btn-light {\n    background: rgba(255, 255, 255, 0.2);\n    border: none;\n    color: #fff;\n    font-size: 13px;\n    text-transform: uppercase;\n}\n.btn-lg {\n    padding: 13px 46px;\n}\n.custom-checkbox .custom-control-label::before {\n    border-radius: 0px;\n    border: none;\n    background: #404040;\n    box-shadow: none !important;\n}\n.custom-control {\n    line-height: 26px;\n}\n.form-control {\n    background: #404040;\n    border: 1px solid #404040;\n    border-radius: 0px;\n    font-size: 14px;\n    min-height: 42px;\n    box-shadow: none !important;\n}\n.form-control:focus {\n    background: #121212;\n    border: none;\n    border: 1px solid #6c757d;\n}\n.custom-control label {\n    color: rgba(255,255,255,.5)!important;\n    width: 100%;\n    cursor: pointer;\n}\ninput[type=text], input[type=tel], input[type=number], input[type=email], textarea, input[type=password] {\n    color: #ffffff !important;\n}\n.card {\n    border-radius: 0px;\n    border: none;\n    background: #2a2a2a;\n}\n.card-body {\n    color: rgba(255,255,255,.5)!important;\n}\n.media .rounded-circle {\n    width: 40px;\n}\n.follow-us a {\n    color: #878787;\n    font-size: 26px;\n    margin: 0 18px;\n}\n.follow-us:hover a {\n    color: #fff;\n}\n.follow-us a:hover {\n    color: #878787;\n}\n.rating {\n    padding: 36px !important;\n}\n.specifications .nav-tabs {\n    border-color: #616161 !important;\n    margin-bottom: 30px;\n}\n.specifications .nav-tabs .nav-link {\n    border: none;\n    position: relative;\n    border-radius: 0px;\n    font-size: 13px;\n    color: rgba(255,255,255,.5);\n    padding: 0 0 29px 0;\n}\n.specifications .nav-tabs .nav-link.active {\n    background: transparent !important;\n    color: #fff;\n}\n.specifications .nav-tabs .nav-item {\n    margin: 0 30px 0 0;\n}\n.specifications .nav-tabs .nav-link:after {\n   content: \"\";\n   height: 5px;\n   background: transparent;\n   position: absolute;\n   left: 0;\n   right: 0;\n   bottom: -1px;\n}\n.specifications .nav-tabs .nav-link.active:after {\n    background: #007bff;\n}\n.btn-outline-facebook {\n    color: #ffffff !important;\n    background: #3B5998 !important;\n}\n.btn-outline-instagram {\n    background: #125688 !important;\n    color: #fff !important;\n}\n.alert {\n    border-radius: 0px;\n    border: none;\n}\n.custom-select.is-invalid, .was-validated .custom-select:invalid, .jumbotron {\n    background-color: #2a2a2a;\n}\n.dropdown-divider {\n    border-top: 1px solid #353535;\n}\n.custom-select {\n    border: none;\n    border-radius: 0px;\n    background-color: #2a2a2a;\n    font-size: 14px;\n    min-height: 42px;\n}\n.custom-file-label {\n    border: none;\n    border-radius: 0px;\n    background-color: #2a2a2a;\n    font-size: 14px;\n}\n.form-control:disabled, .form-control[readonly] {\n    background-color: #000000;\n}\n.bg-light {\n    background-color: #f8f9fa!important;\n    color: #000;\n}\n.bg-light .card-body{\n    color: #000 !important;\n}\n.breadcrumb, .input-group-text {\n    background-color: #2a2a2a;\n    border-color: #2a2a2a;\n}\n.list-group-item{\n    background-color: #2a2a2a;\n}\n.dropdown-menu {\n    background: #2a2a2a;\n    border-radius: 0px;\n    margin: 0;\n    border: 1px solid #353535;\n    color: #fff;\n    box-shadow: 0px 6px 10px rgba(0,0,0,.2)!important;\n}\n.dropdown-item {\n    color: rgba(255,255,255,.5);\n}\n.dropdown-item:hover {\n    background: #000;\n    color: #fff;\n}\n.dropdown:hover .dropdown-menu {\n    display: block;\n   visibility: visible;\n   opacity:1;\n   transform: translateY(0px);\n   transition:.5s ease all;\n}\n.dropdown-menu {\n   display: block;\n   visibility: hidden;\n   opacity:0;\n   transform: translateY(50px);\n   transition:.5s ease all;\n}\n.dropdown-menu.show {\n   display: block;\n   visibility: visible;\n   opacity:1;\n   transform: translateY(0px);\n   transition:.5s ease all;\n}\n.gradient-block h1 {\n    font-size: 54px;\n}\n.help-block ul {\n    margin: 0px;\n    padding: 0px;\n    list-style: none;\n}\n.help-block ul li {\n    color: #f53838;\n    font-size: 12px;\n}\n.carousel-indicators {\n    margin: 11px 18px;\n    left: auto;\n}\n.carousel-control-next, .carousel-control-prev {\n   bottom: auto;\n   background: #000;\n   width: 35px;\n   height: 35px;\n   margin: 15px;\n}\n.carousel-control-next-icon, .carousel-control-prev-icon {\n    width: 12px;\n}\n.carousel-control-prev {\n    right: 36px;\n    left: auto;\n}\n/* End Extra */\n/* Filters */\n.filters-search {\n    position: relative;\n}\n.filters-search i {\n    position: absolute;\n    padding: 15px 14px;\n}\n.filters-search .form-control {\n    padding-left: 42px;\n}\n.filters-card-header .btn-link {\n    font-size: 14px;\n    color: #fff;\n    width: 100%;\n    display: block;\n}\n.filters-card-body {\n    padding: 20px 0 0 0;\n}\n/* End Filters */\n/* Sidebar */\n.img-profile {\n    width: 80px;\n}\n.sidebar-widget {\n    position: relative;\n}\n.sidebar-widget .nav-link {\n    padding: 10px 7px;\n    border-radius: 0px;\n    position: relative;\n    color: #bfbfbf;\n}\n.sidebar-widget .nav-link:hover, .sidebar-widget .nav-link:focus {\n    color: #ffffff;\n}\n.sidebar-widget .nav-link:hover:before, .sidebar-widget .nav-link:focus:before {\n    background: #007bff;\n}\n.sidebar-widget .nav-link i {\n    min-width: 19px;\n    display: inline-block;\n    text-align: center;\n    opacity: 0.5;\n    margin: 0px 8px 0px 0px !important;\n}\n.sidebar-widget .nav-link:before {\n    content: \"\";\n    position: absolute;\n    left: -15px;\n    width: 4px;\n    bottom: 5px;\n    top: 5px;\n    background: #2a2a2a;\n}\n.sidebar-widget .nav-link.active {\n    background: transparent;\n    font-weight: 500;\n}\n.sidebar-widget .nav-link.active:before {\n    background: #fff;\n}\n/* End Sidebar */\n/* Top Nav */\n.navbar-dark .navbar-nav .nav-link {\n    color: rgba(255,255,255,.8);\n}\n.osahan-nav-top .container {\n    padding: 0 16px;\n}\n.osahan-nav-top .img-profile {\n    width: 30px;\n    height: 30px;\n}\n.osahan-nav-top .navbar-brand img {\n    height: 31px;\n    margin: -4px 0 0 0;\n}\n.osahan-nav-top .osahan-list-dropdown .nav-link i {\n    font-size: 16px;\n}\n.osahan-nav-top .osahan-list-dropdown .nav-link .badge {\n    position: absolute;\n    border-radius: 50px;\n    min-width: 15px;\n    height: 15px;\n    font-size: 9px;\n    padding: 0px;\n    right: 1px;\n    line-height: 15px;\n    top: 11px;\n}\n.osahan-nav-top .nav-link {\n    position: relative;\n    height: 55px;\n    display: flex;\n    align-items: center;\n}\n.osahan-nav-top .navbar-search .form-control {\n    background: #121212;\n    min-height: 35px;\n}\n.osahan-nav-top .navbar-search .btn {\n    background: #121212 !important;\n    color: #74828e;\n    padding: 0 12px;\n    border: none;\n}\n.dropdown-list .dropdown-item {\n    white-space: normal;\n    padding-top: .5rem;\n    padding-bottom: .5rem;\n    border-left: 1px solid #353535;\n    border-right: 1px solid #353535;\n    border-bottom: 1px solid #353535;\n    line-height: 1.3rem;\n}\n.dropdown-list {\n    padding: 0;\n    border: none;\n    overflow: hidden;\n    width: 20rem!important;\n}\n.dropdown-list .dropdown-header {\n    background-color: #131313;\n    border: 1px solid #353535;\n    color: #fff;\n    font-weight: 800;\n    font-size: 14px;\n    padding: .8rem 1rem;\n}\n.dropdown-list .icon-circle {\n    height: 2.5rem;\n    width: 2.5rem;\n    border-radius: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.no-arrow .dropdown-toggle::after {\n    display: none;\n}\n.text-truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.dropdown .dropdown-menu, .dropdown-item {\n    font-size: .85rem;\n}\n.text-gray-500 {\n    color: #b7b9cc!important;\n}\n.dropdown-list-image {\n    position: relative;\n    height: 2.5rem;\n    width: 2.5rem;\n}\n.dropdown-list-image img {\n    height: 2.5rem;\n    width: 2.5rem;\n}\n.dropdown-list-image .status-indicator {\n    background-color: #eaecf4;\n    height: .75rem;\n    width: .75rem;\n    border-radius: 100%;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    border: .125rem solid #fff;\n}\n.dropdown-item {\n    padding: 6px 1rem;\n}\n/* End Top Nav */\n/* Card */\n.osahan-card {\n    margin-bottom: 35px;\n}\n.osahan-card-body h6 {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n/* End Card */\n/* Footer */\n.footer ul {\n    margin: 0px;\n    padding: 0px;\n    list-style: none;\n}\n.footer ul li a {\n    color: rgba(255,255,255,.5)!important;\n}\n.footer ul li {\n    line-height: 28px;\n}\n.footer ul li a:hover {\n    opacity: unset;\n}\n.footer h6 {\n    font-size: 14px;\n    margin-bottom: 20px;\n}\n.app .img-fluid {\n    height: 32px;\n}\n/* End Footer */\n/* Mobile Media */\n\n@media (min-width: 0px) and (max-width: 767px) {\n    .container {\n\t\tmax-width: 100%;\n    }\n    .osahan-login {\n        max-width: 430px;\n        margin: auto;\n    }\n    .osahan-nav-top {\n        padding: 0 0 !important;\n    }\n    .p-5 {\n        padding: 2rem!important;\n    }\n    .osahan-nav-top .dropdown {\n        position: static;\n    }\n    .osahan-nav-top .dropdown .dropdown-menu {\n        left: 0;\n        right: 0;\n        width: 100% !important;\n    }\n    .position-sticky {\n        margin-bottom: 30px;\n    }\n    .footer{\n        display: none;\n    }\n    .footer ul li {\n        text-align: center;\n    }\n    .footer h6 {\n        text-align: center;\n        margin: 30px 0 8px 0;\n    }\n    .footer-brand {\n        text-align: center;\n    }\n    .newsletter-form .btn {\n        width: 100%;\n    }\n    .app {\n        text-align: center;\n    }\n    .osahan-copyright p {\n        width: 100%;\n        text-align: center;\n        padding: 5px 0;\n    }\n    .osahan-copyright .d-flex {\n        display: unset !important;\n    }\n}\n@media (min-width: 768px) and (max-width: 1023px) {\n    .container {\n\t\tmax-width: 100%;\n    }\n    .footer h6 {\n        margin: 30px 0 8px 0;\n    }\n    .footer-brand{\n        margin-top: 30px;\n    }\n}\n@media (min-width: 1024px) and (max-width: 1200px) {\n\t.container {\n\t\tmax-width: 100%;\n\t}\n}\n/* End Mobile Media */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
